import React from 'react'

const AnimatedList = ({ child, keyItem }) => {
    return (
        <tr
            key={keyItem}
            id= "list-items"
            className=" bg-[#FFFFFF] rounded-[16px]"
        >
            {child}
        </tr>
    );
}

export default AnimatedList;